// extracted by mini-css-extract-plugin
export var description = "details-module--description--2632f";
export var fadeInAnimation = "details-module--fadeInAnimation--95be1";
export var hiddenContent = "details-module--hiddenContent--b717e";
export var hide = "details-module--hide--27d6f";
export var popUp = "details-module--popUp--666a9";
export var popUpSection = "details-module--popUpSection--74550";
export var row = "details-module--row--c3afc";
export var tag = "details-module--tag--ae9fd";
export var technologiesWrapper = "details-module--technologiesWrapper--abd35";
export var title = "details-module--title--d6ef1";
export var viewButton = "details-module--viewButton--a6d0f";
export var visible = "details-module--visible--60994";
export var wrapper = "details-module--wrapper--eb2be";